import React from 'react'

const PurchaseReceives = () => {
  return (
    <div>PurchaseReceives</div>
  )
}

export default PurchaseReceives